// Saves the Edit User form: only what changed, each through the route that
// handles it - the email as a Cognito attribute, the groups by replacing the
// user's groups. The form used to send only { email } (in a shape the server
// refused), so groups picked there, such as CallAgent, were never saved.
const sameGroups = (a, b) => [...a].sort().join('\n') === [...b].sort().join('\n');

export async function saveUserEdits(username, before, after, api) {
  const emailChanged = (after.email || '') !== (before.email || '');
  const groupsChanged = !sameGroups(after.groups || [], before.groups || []);
  if (groupsChanged && (after.groups || []).length === 0) {
    // The groups route can only replace groups with at least one.
    throw new Error('A user needs at least one group.');
  }
  if (emailChanged) {
    await api.updateUser(username, { email: after.email });
  }
  if (groupsChanged) {
    await api.setUserGroups(username, after.groups);
  }
  return { emailChanged, groupsChanged };
}
